/**
 * Nederlandstalige labels voor de deterministische rapportviewer (M19 / US07A).
 * Classificatie en beschikbaarheid moeten in de UI altijd expliciet zichtbaar
 * zijn: feiten en schattingen worden nooit zonder label naast elkaar gezet en
 * ontbrekende data is "Niet beschikbaar", nooit 0.
 */
export const CLASSIFICATION_LABELS = {
    FACT: 'Feit',
    ESTIMATE: 'Schatting',
    INFERENCE: 'Afleiding',
};
export const AVAILABILITY_LABELS = {
    AVAILABLE: 'Beschikbaar',
    NOT_AVAILABLE: 'Niet beschikbaar',
    NOT_APPLICABLE: 'Niet van toepassing',
    ERROR: 'Fout bij ophalen',
};
export const COMPARABILITY_STATUS_LABELS = {
    COMPARABLE: 'Vergelijkbaar',
    COMPARABLE_WITH_WARNINGS: 'Vergelijkbaar met kanttekeningen',
    NOT_COMPARABLE: 'Niet vergelijkbaar',
    INSUFFICIENT_DATA: 'Onvoldoende gegevens',
};
export const METRIC_CATEGORY_LABELS = {
    WEBSITE: 'Website',
    SEO: 'SEO (organische vindbaarheid)',
    SEA: 'SEA (advertentie-indicaties)',
    SEARCH_CONSOLE: 'Eigen zoekprestaties (Search Console)',
    FIRST_PARTY: 'Eigen websitedata',
    SOCIAL: 'Social & marketing',
    POSITIONING: 'Positionering',
};
export const SOURCE_FAMILY_LABELS = {
    WEBSITE: 'Publieke website',
    GOOGLE_SEARCH: 'Google Zoeken',
    SE_RANKING: 'SE Ranking',
    GOOGLE_ADS: 'Google Ads',
    SEARCH_CONSOLE: 'Search Console',
    SALESFEED: 'Salesfeed',
    SOCIAL_PLATFORMS: 'Socialplatforms',
    MANUAL: 'Handmatig',
};
export const CONNECTOR_RUN_STATUS_LABELS = {
    PENDING: 'In wachtrij',
    RUNNING: 'Bezig',
    SUCCESS: 'Gelukt',
    PARTIAL: 'Gedeeltelijk gelukt',
    FAILED: 'Mislukt',
    SKIPPED: 'Overgeslagen',
    CANCELLED: 'Geannuleerd',
};
//# sourceMappingURL=report-labels.js.map